import { createStyles } from "@envestnet/envreact-component-library";
import type { WithStyles } from "@envestnet/envreact-component-library";

const styles = () =>
  createStyles({
    container: {
      display: "flex",
      justifyContent: "center",
      flexDirection: "row",
      height: "100%",
      "& > div": {
        marginTop: 84,
        width: 360,
        marginBottom: 100,
        textAlign: "center",
      },
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
